export default function ToastBox({ toasts, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        zIndex: 9999
      }}
    >
      {toasts.map(t => (
        <div
          key={t.id}
          className={`alert alert-${t.type} shadow m-0 py-2 px-3 d-flex align-items-center justify-content-between`}
        >
          <span>{t.text}</span>
          <button className="btn-close" onClick={() => onClose(t.id)} />
        </div>
      ))}
    </div>
  );
}
